"use client";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { LeadershipGrid } from "@/components/LeadershipGrid/LeadershipGrid";
import { Layout } from "@/components/Layout/Layout";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
export default function Leadership({ pageData }) {
	const [activeTab, setActiveTab] = useState(1);
	return (
		<Layout lightHeader={false}>
			<HeroHeader heading={"Leadership Team"} subHeading={""} />
			<section className="pb-16">
				<div className="flex flex-col items-center gap-8">
					<div className="hp-container mt-8 w-full">
						{activeTab === 1 ? (
							<LeadershipGrid members={pageData.leadership.members} />
						) : (
							<LeadershipGrid members={pageData.directors.members} />
						)}
					</div>
				</div>
			</section>
		</Layout>
	);
}
